import FilesIcon from "./components/Icons/FilesIcon";
import GithubIcon from "./components/Icons/GitHubIcon";
import CodeIcon from "./components/Icons/CodeIcon";
import PencilIcon from "./components/Icons/PencilIcon";
import MailIcon from "./components/Icons/MailIcon";
import AccountIcon from "./components/Icons/AccountIcon";

export const destinations = [
	{ name: "home", label: "Home", filename: "home.tsx", icon: "react_icon.svg", Icon: FilesIcon },
	{ name: "about", label: "About", filename: "about.html", icon: "html_icon.svg", Icon: AccountIcon },
	{ name: "contact", label: "Contact", filename: "contact.css", icon: "css_icon.svg", Icon: MailIcon },
	{ name: "projects", label: "Projects", filename: "projects.js", icon: "js_icon.svg", Icon: CodeIcon },
	{ name: "articles", label: "Articles", filename: "articles.json", icon: "json_icon.svg", Icon: PencilIcon },
	{ name: "github", label: "GitHub", filename: "github.md", icon: "markdown_icon.svg", Icon: GithubIcon },
	{ name: "helper", label: "Helper Functions", filename: "helperFunctions.tsx", icon: "react_icon.svg", Icon: CodeIcon },
	{ name: "meterMan", label: "Meter Man", filename: "meterMan.tsx", icon: "react_icon.svg", Icon: FilesIcon },
] as const;

export type Navigation = typeof destinations[number]["name"];

export interface NavigationProps {
	active: Navigation;
	navigateCallback: (name: Navigation) => void;
}
